module.exports = __webpack_public_path__ + "img/bg2.84de25c6.png";